import { render, staticRenderFns } from "./pending-table.vue?vue&type=template&id=64784200&scoped=true&"
import script from "./pending-table.vue?vue&type=script&lang=js&"
export * from "./pending-table.vue?vue&type=script&lang=js&"
import style0 from "./pending-table.vue?vue&type=style&index=0&id=64784200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64784200",
  null
  
)

export default component.exports